import React from 'react';
import * as Styled from '../../showroom-lite.styled';
import { dataAttrGUI } from '@at/formatter-utils';
export var GridSkeleton = function (_a) {
    var _b;
    var uniqueId = _a.uniqueId, $width = _a.$width, $count = _a.$count;
    return (React.createElement(Styled.ShowroomListLoadingSkeleton, (_b = {}, _b[dataAttrGUI] = "".concat(uniqueId, "-skeleton"), _b.style = { width: $width }, _b),
        React.createElement(Styled.ShowroomGridListLoadingBodyWindow, null, Array.from({ length: $count }).map(function (_, index) { return (React.createElement(Styled.ShowroomListLoadingItem, { key: "loading-item-".concat(index) })); }))));
};
